module.exports = __webpack_public_path__ + "img/dialog-bg.d2696656.png";